import React, {useEffect, useRef} from 'react';

const deep_compare = (a, b) => JSON.stringify(a) === JSON.stringify(b)

const use_deep_compare_memoize = value => {
  const ref = useRef() 

  if (!deep_compare(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

const use_deep_compare = (callback, dependencies) => {
  useEffect(callback, use_deep_compare_memoize(dependencies))
}

export {
	use_deep_compare
}